import { SvgIcon, SxProps } from "@mui/material";
import SvgStarIconLight from "jsx:../../../Images/Icons/FontAwesome/solid/star.svg";

export function StarIconLight(props: SxProps) {
    return <SvgIcon component={SvgStarIconLight} inheritViewBox sx={props} />;
}
